import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
var cache = new WeakMap();
var Timer = /*#__PURE__*/_createClass(function Timer() {
  var _this = this;
  _classCallCheck(this, Timer);
  _defineProperty(this, "getTimer", function () {
    return _this._t;
  });
  _defineProperty(this, "setTimer", function (t) {
    _this._t = t;
  });
});
var getCacheTimer = function getCacheTimer(fn) {
  if (!cache.has(fn)) {
    cache.set(fn, new Timer());
  }
  return cache.get(fn);
};
function executeWhenChangeStop (fn) {
  var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var timer = getCacheTimer(fn);
  var t = timer.getTimer();
  // eslint-disable-next-line no-console
  // console.log(`execute-when-change-stop invoked timer: ${t}`)
  return [period ? function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (t) {
      clearTimeout(t);
    }
    timer.setTimer(setTimeout(function () {
      // eslint-disable-next-line no-console
      // console.log('execute-when-change-stop execute function')
      fn.apply(void 0, args);
    }, period));
  } : fn, function () {
    if (t) {
      clearTimeout(t);
    }
  }];
}

export default executeWhenChangeStop;
//# sourceMappingURL=execute-when-change-stop.esm.js.map
